import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgArrowLeft({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 12 12"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M6.9 10.91l-.6.6a.64.64 0 01-.9 0L.19 6.3a.64.64 0 010-.91l5.2-5.2a.64.64 0 01.91 0l.6.6c.25.25.25.66-.01.91L3.66 4.78h7.7c.35 0 .64.28.64.64v.86c0 .35-.29.64-.64.64h-7.7l3.23 3.07c.26.25.27.67 0 .92z" />
    </svg>
  );
}

SvgArrowLeft.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgArrowLeft.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgArrowLeft svgRef={ref} {...props} />);
export default ForwardRef;
